import { connect } from 'react-redux';

import { fetchCurrentUser } from 'store/actions/current-user-actions';
import { fetchUserOPMProfile } from 'store/actions/user-profile-actions';
import { authenticateUser } from 'store/actions/user-auth-actions';
import {
  initGlobalSocketClient,
  setGlobalSocketClient,
  closeGlobalSocketClient,
} from 'store/actions/global-socket-actions';
import Authorized from 'components/app/authorized-component';

const mapStateToProps = ({ data: { currentUser, authUser } }) => ({
  currentUser,
  authUser,
});

const mapDispatchToProps = {
  fetchUserOPMProfile,
  authenticateUser,
  fetchCurrentUser,
  initGlobalSocketClient,
  setGlobalSocketClient,
  closeGlobalSocketClient,
};

export default connect(mapStateToProps, mapDispatchToProps)(Authorized);
